import Modal from "react-bootstrap/Modal";
function VideoModal({show, handleClose, videoId,}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
    >
      <Modal.Body className="p-0">
        {videoId && (
          <iframe
            width="100%"
            height="500"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video"
            allow="autoplay"
            allowFullScreen
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default VideoModal;